exports.components = {
  "component---src-templates-page-js": () => import("./../../../src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */),
  "component---src-templates-product-category-page-js": () => import("./../../../src/templates/ProductCategoryPage.js" /* webpackChunkName: "component---src-templates-product-category-page-js" */),
  "component---src-templates-product-detail-js": () => import("./../../../src/templates/ProductDetail.js" /* webpackChunkName: "component---src-templates-product-detail-js" */)
}

